import { render, staticRenderFns } from "./CalendarPlus.vue?vue&type=template&id=2956be36&"
import script from "./CalendarPlus.vue?vue&type=script&lang=js&"
export * from "./CalendarPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports